import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';


const styles = theme => ({
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
});


function IconButton(props) {
  const { classes, icon, isLeft, text, ...others } = props;
  const theIcon = isLeft ? React.cloneElement(icon, {className: classes.leftIcon}) : React.cloneElement(icon, {className: classes.rightIcon});
  return (
    <Button variant="contained" className={classes.button} {...others}>
      {isLeft && theIcon}
      {text}
      {!isLeft && theIcon}
    </Button>
  );
}


export default withStyles(styles)(IconButton);


// WEBPACK FOOTER //
// ./src/components/IconButton.js